export default "__VITE_PUBLIC_ASSET__8f04882b__"